import { decode } from "html-entities";

const htmlToText = (str: string | null | undefined) => {
  if (!str) {
    return "";
  }
  return decode(str.replace(/(<([^>]+)>)/gi, ""));
};

export default htmlToText;
